import { useEffect, useRef, useState } from 'react';
import optimizedImages from '../data/optimizedImages.json';

const placeholder = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';

export default function ResponsiveImage({ src, srcSet, alt, sizes = '100vw', defer = false, decoding = 'async', ...props }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(() => !defer || typeof IntersectionObserver === 'undefined');
  const asset = optimizedImages[src];

  useEffect(() => {
    if (!defer || visible) return;
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) {
        setVisible(true);
        observer.disconnect();
      }
    }, { rootMargin: '250px' });
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [defer, visible]);

  const load = !defer || visible;
  const image = <img
    ref={ref}
    width={asset?.width}
    height={asset?.height}
    {...props}
    alt={alt}
    src={load ? asset?.src || src : placeholder}
    srcSet={load ? srcSet || asset?.srcSet : undefined}
    sizes={sizes}
    decoding={decoding}
  />;
  return asset?.avifSrcSet ? <picture style={{ display: 'contents' }}>
    <source type="image/avif" srcSet={load ? asset.avifSrcSet : undefined} sizes={sizes} />
    {image}
  </picture> : image;
}
